import React, { useState } from "react";
import DelTaskCardModal from "../../modals/delTaskCardModal";

const TaskCard = ({ taskcardData }) => {
  const [isdelModalOpen, setIsdelModalOpen] = useState(false);
  
  const ondelClick = () => {
    setIsdelModalOpen(true);
  };
  return (
    <>
       {(taskcardData || []).map((reminder, index) => (  // Ensure taskcardData is always an array
        <div
          key={index}
          className="flex flex-col items-center gap-[8px] bg-[#FBFBFB] pr-[28px] pl-[20px] py-[16px] rounded-[10px] shadow-md"
        >
          <div className="flex justify-between w-full items-start">
            <p className="font-semibold text-darkGrey font-manrope medium">
              {reminder.heading}
            </p>
          </div>

          <div className="flex justify-between w-full items-end">
            <p className="font-medium text-darkGrey font-manrope small">
              {reminder.date}
            </p>
            <p
              className="cursor-pointer small font-medium font-manrope underline text-red"
              onClick={ondelClick}
            >
              Delete
            </p>
          </div>
        </div>
      ))}

      <DelTaskCardModal
        isdelModalOpen={isdelModalOpen}
        setIsdelModalOpen={setIsdelModalOpen}
      />
    </>
  );
};

export default TaskCard;
